<div class="sidenav" [class.collapsed]="isCollapsed">
  <ul>
    @for (item of menuItems; track trackByIndex($index)) {
      @if (item.isSeparator) {
        <hr class="custom-hr" />
      } @else {
        @if (item.permission) {
          <li>
            <!-- Parent menu item with children (collapsible) -->
            @if (item.children && item.children.length > 0) {
              <a [routerLink]="item.route" [class.active]="isRouteActive(item)" [title]="item.title | translate" class="flex-container parent-menu">
                @if (isAssetPath(item.icon)) {
                  <img [src]="item.icon" [class.big-img]="item.largeImage" />
                } @else {
                  <mat-icon class="sidenav-icon">{{ item.icon }}</mat-icon>
                }
                @if (isCollapsed) {
                  <span>{{ item.title | translate}}</span>
                }
                <mat-icon
                  class="expand-icon"
                  [class.expanded]="item.expanded"
                  (click)="toggleMenuExpand(item); $event.preventDefault(); $event.stopPropagation()"
                >expand_more</mat-icon>
              </a>
              <!-- Child menu items -->
              @if (item.expanded) {
                <ul class="child-menu" [@.disabled]="true">
                  @for (child of item.children; track child) {
                    @if (child.permission) {
                      <li>
                        <a [routerLink]="child.route" [class.active]="isRouteActive(child)" class="flex-container child-item">
                          @if (child.icon && isAssetPath(child.icon)) {
                            <img [src]="child.icon" [class.big-img]="child.largeImage" />
                          } @else {
                            @if (child.icon) {
                              <mat-icon class="sidenav-icon">{{ child.icon }}</mat-icon>
                            }
                          }
                          @if (isCollapsed) {
                            <span>{{ child.title | translate}}</span>
                          }
                        </a>
                      </li>
                    }
                  }
                </ul>
              }
            } @else {
              <a [routerLink]="item.route" [class.active]="isRouteActive(item)" [title]="item.title | translate" class="flex-container">              @if (isAssetPath(item.icon)) {
                <img [src]="item.icon" [class.big-img]="item.largeImage" />
              } @else {
                <mat-icon class="sidenav-icon">{{ item.icon }}</mat-icon>
              }
              @if (isCollapsed) {
                <span>{{ item.title | translate}}</span>
              }
            </a>
          }
          <!-- Regular menu item (no children) -->
        </li>
      }
    }
  }
</ul>
</div>